import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

let menus = [];

//#!if readonly === true
menus = [
  nativeCommsMessageTypes.SHOW_MINDMAP,
  nativeCommsMessageTypes.SPLIT_HORIZONTALLY,
  nativeCommsMessageTypes.SPLIT_VERTICALLY,
  nativeCommsMessageTypes.ADD_SPLIT_TOP,
  nativeCommsMessageTypes.ADD_SPLIT_BOTTOM,
  nativeCommsMessageTypes.ADD_SPLIT_LEFT,
  nativeCommsMessageTypes.ADD_SPLIT_RIGHT,
  nativeCommsMessageTypes.CLOSE_SPLIT,
  nativeCommsMessageTypes.CLOSE_OTHER_SPLITS,
  "viewMode",
  nativeCommsMessageTypes.SHOW_TIMELINE,
  nativeCommsMessageTypes.SHOW_SPREADSHEET,
  nativeCommsMessageTypes.SHOW_RELATIONSHIPS,
  nativeCommsMessageTypes.SHOW_SUBWAY,
  nativeCommsMessageTypes.SHOW_NARRATIVE,
  nativeCommsMessageTypes.SHOW_OUTLINE,
  "mindMapView",
  "splitView",
  "showItemList",
  "filters",
  nativeCommsMessageTypes.SHOW_SETTINGS,
  "textSize",
  "enterFullScreen",
  nativeCommsMessageTypes.EXPAND_PARENT_ITEM,
  nativeCommsMessageTypes.COLLAPSE_PARENT_ITEM
];
//#!endif

export default menus;
